<template>
    <div class="Input InputCheckbox">
        <el-checkbox
            :name="'input-' + name"
            v-model="localModel"
            :value="label"
            :label="label"
            :class="{ error: localErrors.length }"
        ></el-checkbox>
        <div v-if="errors" class="Input__error">{{localErrors[0]}}</div>
    </div>
</template>

<style lang="sass">
    @import ../../../common/styles/mixins
    @import ../../../common/styles/settings

    .InputCheckbox
        .el-checkbox
            display: flex
            white-space: inherit

            &.error
                .el-checkbox__inner
                    border: 1px solid $color-base

        .el-checkbox__inner
            width: 24px
            height: 24px

            &:after
                width: 5px
                height: 9px
                top: 4px
                left: 8px
                border: 2px solid $color-white
                border-top: 0
                border-left: 0


        .el-checkbox__inner:hover,
        .el-checkbox__input.is-focus .el-checkbox__inner
            border-color: $color-base

        .el-checkbox__input.is-checked .el-checkbox__inner,
        .el-checkbox__input.is-indeterminate .el-checkbox__inner
            background-color: $color-base
            border-color: $color-base

        .el-checkbox__input.is-checked+.el-checkbox__label
            color: $color-text
        .el-checkbox__label
            font-weight: 400
            font-size: 0.875rem


</style>

<script>

    export default {
        props: ["name", "value", "label", "errors"],
        data() {
            return {
                localModel: ( this.value !== "" ),
                localErrors: this.errors || []
            }
        },
        watch: {
            localModel(val) {
                this.$emit("input", val ? this.label : "");
            },
            value: function(newVal, oldVal) {
                this.localModel = ( newVal !== "" );
            },
            errors: function(newVal, oldVal) {
                this.localErrors = newVal || [];
            }
        }
    }

</script>
